import React, { useEffect } from 'react';

import { Switch, Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Routes } from 'routing';

import { useDispatch } from 'react-redux';
import * as StockSelectors from 'selectors/StockSelectors';
import * as UserSelectors from 'selectors/UserSelectors';
import * as NewRentalActions from 'actions/NewRentalActions';

import Spinner from 'components/Spinner';
import NotFound from 'views/404';

import NewRental from './NewRental';
import RentalShopperInfo from './RentalShopperInfo';
import RentalComplete from './ReservationDone';
import RentalLinkSent from './RentalLinkSent';
import ReservationDone from './ReservationDone';
import RentalLinkInfo from './RentalLinkInfo';
import CreateBookingPromoPage from 'components/features/promos/CreateBookingPromoPage';
import HasFeature from 'components/features/HasFeature';
import Container from 'components/Container';

const NewRentalRouter = () => {
	const dispatch = useDispatch();
	const isLoading = useSelector(StockSelectors.isStockLoading);
	const activeLocationId = useSelector(UserSelectors.userActiveLocationId);

	useEffect(() => {
		dispatch(NewRentalActions.resetNewRentalState());
		return () => {
			dispatch(NewRentalActions.resetNewRentalState());
		};
	}, [dispatch, activeLocationId]);

	if (isLoading || !activeLocationId) return <Spinner in={true} />;

	return (
		<HasFeature
			requiredFeature="NEW_RENTAL"
			fallback={(failedChecks) => {
				if (failedChecks.user) return <Redirect to={Routes.HOME_VIEW} />;
				return (
					<Container>
						<CreateBookingPromoPage />
					</Container>
				);
			}}
		>
			<React.Fragment key={activeLocationId}>
				<Switch>
					<Route exact path={Routes.NEW_RENTAL} component={NewRental} />
					<Route exact path={Routes.NewRentalShopperInfo('link')} component={RentalLinkInfo} />
					<Route exact path={Routes.NEW_RENTAL_SHOPPERINFO} component={RentalShopperInfo} />
					<Route exact path={Routes.NewRentalDone('reservation')} component={ReservationDone} />
					<Route exact path={Routes.NewRentalDone('link')} component={RentalLinkSent} />
					<Route exact path={Routes.NewRentalDone('rent-now')} component={RentalComplete} />
					<Route component={NotFound} />
				</Switch>
			</React.Fragment>
		</HasFeature>
	);
};

export default NewRentalRouter;
